import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UnsavedChangesService } from './unsaved-changes.service';

@Component({
  selector: 'unsaved-changes-outlet',
  template: `<unsaved-changes
    *ngIf="showModal"
    (close)="handleClose($event)"
  ></unsaved-changes>`,
})
export class UnsavedChangesOutletComponent implements OnDestroy {
  showModal = false;
  private subscription: Subscription;

  constructor(private unsavedChangesService: UnsavedChangesService) {
    this.subscription = this.unsavedChangesService.showModal$.subscribe(
      show => (this.showModal = show),
    );
  }

  handleClose(confirmed: boolean): void {
    this.unsavedChangesService.toggleModal(false);
    this.unsavedChangesService.reportDecision(confirmed);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
